module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/order-fulfillment-7f7501dff98c02f414dedb21d0e14a02.svg";